import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import scrollSlice from "./slices/scrollSlice";
import routerSlice from "./slices/routerSlice";
import localeSlice from "./slices/localeSlice";

export const store = configureStore({
  reducer: {
    locale: localeSlice,
    scroll: scrollSlice,
    router: routerSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
